import ClubProfile from "@/profile/ClubProfile.tsx";
import {PublicClubProfile} from "@/types";
import queryKeys from "@/utilities/queryKeys.ts";
import {useQuery} from "@tanstack/react-query";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";
import {apiRetrieveImproved} from "../../../../api.ts";

export const Route = createFileRoute('/_app/clubs/$club_uid/')({
    validateSearch: (search: Record<string, unknown>) => ({
        modal: search.modal as string | undefined,
    }),
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});

    const profileQuery = useQuery<PublicClubProfile>({
        queryKey: queryKeys.profile(params.club_uid!),
        queryFn:  async () => apiRetrieveImproved('public-club-profile' as any, {club_uid: params.club_uid}),
        enabled:  !!params.club_uid,
    })

    return <ClubProfile profile={profileQuery.data} />
}
